import { connect } from "react-redux";
import SummaryHeader from "./SummaryHeader";
import { matchModeLabel } from "../../constants";
import { selectTrendTotals } from "../../utils/selectTrendTotals";

// The split comes from selectTrendTotals, which reads it from the load that
// built the lists rather than from the latest response — this line describes
// everyone the filters leave in scope, so a search over the tables below must
// not rewrite it.
const mapStateToProps = (state) => {
    const { fetchProjectComparisonApi, fetchProjectNotComparedApi, trendPairing } = state.BenchmarkFilteringReducer;
    const { totalCount, comparedCount, notComparedCount } = selectTrendTotals(state);

    return {
        matchedCount: comparedCount,
        notComparedCount,
        // Held back until the first load has answered — a half-built line
        // reading "0 matched" under the loader is worse than no line.
        hasCounts: !(fetchProjectComparisonApi.isInitialLoading || fetchProjectNotComparedApi.isInitialLoading)
            && totalCount > 0,
        // The pairing the results are built from, not the one being edited —
        // same reason TrendFooter warns about unsaved changes instead of
        // describing them.
        matchModeLabel: matchModeLabel(trendPairing.applied.matchMode),
    };
};

export default connect(mapStateToProps)(SummaryHeader);
